import { useContext, useMemo } from 'react';
import { FilterValue } from 'components/filter/types';
import { TableContext } from 'components/table/TableContext';

const useFlattenedTableColumnFilters = () => {
    const { table } = useContext(TableContext);

    const filterState = table.getState().givebutterColumnFilters;

    return useMemo(
        () =>
            Object.entries(filterState).reduce((prev, [_, curr]) => {
                return [...prev, ...(curr || []).map(f => f.filters).flat()];
            }, [] as FilterValue[]),
        [filterState],
    );
};

export { useFlattenedTableColumnFilters };
